module.exports = __webpack_public_path__ + "media/assets/partners/shopmatic-6772cbf0bd4bfb5bd5b7b73697748bfd.svg";